import { useState, useEffect } from "react";
import SwiperNacio from '../components/SwiperNacio'
import BrandShape from '../components/BrandShape'
import { FaCar, FaYoutube, FaCog } from "react-icons/fa";
import Tranzicija from "../components/Tranzicija";

import tvornica from "../img/tvornica.JPEG";
import alkantara from "../img/alkantara.JPEG";

import bmw1 from "../img/bmw1.png";
import bmw2 from "../img/bmw2.png";



const Naslovna = () => {

  return (
<>

  <div className="full-bleed">
  <SwiperNacio />
</div>

<div className="scroll-row home">
   <div className="row container mx-auto mt-5 g-4">

      <div className="col-lg-4 text-center mb-5">
        <div className="future-card">
          <FaCar size={50} className="mb-3 text-primary" />
          <h3>Ugradnja pojaseva</h3>
          <p>Profesionalna ugradnja sigurnosnih pojaseva za sve vrste vozila. Naši stručnjaci osiguravaju pravilnu instalaciju kako bi vaša sigurnost bila na prvom mjestu.</p>
          </div>
    
        </div>
       
           <div className="col-lg-4 text-center brand-shape-model">
            
            <div className="future-card">
              <FaYoutube size={50} className="mb-3 text-danger" />
              <h3>YouTube Sadržaj</h3>
              <p>Naš rad i proces rada možete pratiti na našem YouTube kanalu. Osim edukativnog sadržaja možete pratiti naš rast u sportu, te ostale mnoštvo tema sa Hrvatske auto scene!</p>
              
            </div>
            
        </div>
        

          <div className="col-lg-4 text-center mb-5">

        <div className="future-card">
          <FaCog size={50} className="mb-3 text-dark" />
          <h3>Custom dizajn volana</h3>
          <p>Izrada custom volana za vaše vozilo sa prilagodbom na vaš stil i potrebu. Više od 10 boja i stilova u kombinaciji sa čak 4 materijala izrade i ovlikom kakav želite. </p>
   
          </div>
        </div>
      </div>
    </div>

    <h2 className="text-center mb-5">Pogledaj transformaciju zadovoljnih klijenata</h2>

<div className="row container mx-auto mt-5 g-4 tranzicija-wrapper">
  <div className="col-md-6 tranzicija-col">
    <Tranzicija beforeImage={bmw1} afterImage={bmw2} height="700px" />
  </div>
  <div className="col-md-6 tranzicija-col">
    <Tranzicija beforeImage={tvornica} afterImage={alkantara} height="700px" />
  </div>
</div>

<div className="container my-5">

  {/* LOKACIJA */}
  <div className="text-center mb-4">
    <h2>Gdje se nalazimo</h2>
    <p style={{ color: "rgba(255,255,255,0.6)", marginBottom: "16px" }}>
      Gambetići 1b, 52440, Poreč
    </p>
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2809.5390853409667!2d13.7553482!3d45.23689059999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x477ca3c0691a9c01%3A0x37a24cd6d9fb7938!2sCarbon%20CRO!5e0!3m2!1shr!2shr!4v1781085212484!5m2!1shr!2shr" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
      width="100%"
      height="300"
      style={{ border: 0, borderRadius: "20px" }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title="CarbonCro lokacija"
    />
  </div>

  {/* YOUTUBE */}
  <div className="text-center mb-4 youtube-section">
    <h2>Pratite nas na YouTube-u</h2>
    <p>Za više transformacija, savjeta i zabavnog sadržaja, posjetite naš YouTube kanal!</p>
  </div>
  <iframe
    className="w-100"
    height="315"
    src="https://www.youtube.com/embed/7lv_qB0tw2k?si=r4ZXjCduax_aZHs3"
    title="YouTube video player"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerPolicy="strict-origin-when-cross-origin"
    allowFullScreen
  />
</div>



</>
 
  )
}

export default Naslovna
